import queryString from 'query-string';
import vAxios from './vAxios';
import {RequestConfig} from "@/common/request/vHttpInterface";
import {HttpResponseInterface, HttpParamsInterface} from '../utils/responseUtil';

// 只处理参数， 响应是axios 返回，如果还需要更精细的， 请直接自己用axios , 不走封装
export const baseHttp = {
  get<D = any>(url: string, params?: HttpParamsInterface, config?: RequestConfig) {
    if (params) {
      const paramsString = queryString.stringify(params);
      const connectSymbol = url.includes('?') ? '&' : '?';
      if (paramsString) {
        url = url + connectSymbol + paramsString;
      }
    }
    return vAxios.get(url, config);
  },
  post<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig) {
    return vAxios.post(url, params, config);
  },
  put<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig) {
    return vAxios.put(url, params, config);
  },
  postForm<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig) {
    return vAxios.postForm(url, params, config);
  },
  delete<D = any>(url: string, params?: HttpParamsInterface, config?: RequestConfig) {
    if (params) {
      const paramsString = queryString.stringify(params);
      const connectSymbol = url.includes('?') ? '&' : '?';
      if (paramsString) {
        url = url + connectSymbol + paramsString;
      }
    }
    return vAxios.delete(url, config);
  },
};


// 使用者只需要处理 http status === 200 ; 其他 302、406、 500 之类的请求错误，统一处理
const vHttp = {
  get<D = any>(url: string, params?: HttpParamsInterface, config?: RequestConfig): Promise<HttpResponseInterface> {
    return new Promise<HttpResponseInterface>((resolve) => {
      baseHttp.get(url, params, config).then(res => {
        resolve(res.data);
      }).catch(() => {
        resolve({
          code: -99
        });
      });
    });
  },
  post<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig): Promise<HttpResponseInterface> {
    return new Promise<HttpResponseInterface>((resolve) => {
      baseHttp.post(url, params, config).then(res => {
        resolve(res.data);
      }).catch(() => {
        resolve({
          code: -99
        });
      });
    });
  },
  put<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig): Promise<HttpResponseInterface> {
    return new Promise<HttpResponseInterface>((resolve) => {
      baseHttp.put(url, params, config).then(res => {
        resolve(res.data);
      }).catch(() => {
        resolve({
          code: -99
        });
      });
    });
  },
  postForm<D = any>(url: string, params: HttpParamsInterface, config?: RequestConfig): Promise<HttpResponseInterface> {
    return new Promise<HttpResponseInterface>((resolve) => {
      baseHttp.postForm(url, params, config).then(res => {
        resolve(res.data);
      }).catch(() => {
        resolve({
          code: -99
        });
      });
    });
  },
  delete<D = any>(url: string, params?: HttpParamsInterface, config?: RequestConfig): Promise<HttpResponseInterface> {
    return new Promise<HttpResponseInterface>((resolve) => {

      baseHttp.delete(url, params, config).then(res => {
        resolve(res.data);
      }).catch(() => {
        resolve({
          code: -99
        });
      });
    });
  },
};

export default vHttp;
